import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { connect } from 'react-redux';
import withRouter from 'components/components/common/withRouter';
import T from 'components/common/translations/Translate';
import TransHelper from 'components/common/translations/TransHelper';

class Confirmed extends Component {

  trans = (key) => {
    return TransHelper.translate(this.props.locale, 'content.common.contact.' + key);
  }

  handleClick = (e) => {
    e.preventDefault();
    if (this.props.isLogged) {
      TransHelper.redirect(this.props, 'routes.url.dashboard');
    } else {
      TransHelper.redirect(this.props, 'routes.url.booking');
    }
  }

  trans = (key,prefix = "content.bookingStepFinal") => {
    return TransHelper.translate( this.props.locale, prefix + '.' + key);
  }

  render() {
    return (
      <div className="content bg--negative confirmed" style={{ padding: 0 }}>
        <div className="">
          <header className="branding branding--airplane-light" style={{ marginBottom: '-10px' }} />

          <header className="head mb-30">
            <h3>{this.trans('title')}</h3>
          </header>

          <div className='confirmed__desc'>
            <p>{this.trans('info.first')}</p>
            <p>{this.trans('info.second')}</p>
            <p className="mb-40">{this.trans('info.third')}</p>
            <ul className="list-none mb-80">
              <li>
                <a href={`mailto:${this.trans('email')}`} title={this.trans('emailTitle')}>
                  <FontAwesomeIcon
                    icon="envelope"
                    size="lg"
                    style={{ position: 'relative', left: '-10px' }}
                  /><T>content.common.contact.email</T></a>
              </li>
            </ul>
            <button
              className="button button--outline button--expand"
              onClick={this.handleClick}
            >
              {this.trans('confirm')}
            </button>
          </div>
        </div>

        <a
          onClick={this.handleClick}
          className="button button--close"
        >
          <FontAwesomeIcon
            icon={['fas', 'times']}
            size="lg"
          />
          <span className="visuallyhidden">close</span>
        </a>

      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isLogged: state.app.isLogged,
    locale: state.app.locale
  };
};

export default withRouter(connect(mapStateToProps)(Confirmed));
